export default "__VITE_ASSET__CPUkWil5__"